<template>
    <div class="modal fade modal-footer-sticky" id="logoutmodal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog onload-modal  exit-clickbet">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="thm-heading">
                        <h3>Exit</h3>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body ">
                    <div class="modal-info">
                        <img src="@/assets/images/exit-clickbet-icon.svg" alt="">
                    </div>
                    <div class="thm-heading d-inline-block text-center m-auto w-100">
                        <h3>Exit Clickbet?</h3>
                        <p>Are you sure you want to quit?</p>
                    </div>
                </div>
                <div class="header-but  info-footer edit-stake-btn mt-0">
                    <div class="back-modal-footer ">
                        <a  class=" place-but thm-bor-but  text-center thm-but" ref="close_btn" data-bs-dismiss="modal">No</a>
                        <a  @click="logoutBtnClick()" class="btn thm-bor-but   text-center">Yes</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { AUTH_TOKEN } from '@/shared/constants/cookies-const';
import api from '../services/api';
import * as apiName from '../services/urls';

export default {
    name: "LogoutModal",
    methods:{
        logoutBtnClick() {
            this.logoutServiceCall();
        },
        logoutServiceCall() {
            
            let headers = {
                'Authorization': `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
            }
            api.get(apiName.LOGOUT_API, { headers }).then(response => {
                console.log("Result Logout API : ", response);
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        console.log("response", response);
                        if (response?.data?.status == 0) {
                            this.$emit('error-modal',response.data.debug[0])
                        }
                        else {
                            this.$emit('success-modal',response?.data?.message);
                            localStorage.removeItem('is_offer');
                            // remove all cookie
                            this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie))
                            this.$store.dispatch('resetAllState');
                            this.$refs.close_btn.click();
                            location.href ='/login'
                            this.$emit('close');
                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    console.log("Error Login : ", error[0]);
                    this.$emit('error-modal',error[0]);
                }
            });
        },
    },
    emits: ['close', 'success-modal', 'error-modal'],
};
</script>